// extracted by mini-css-extract-plugin
export var content = "StrapiEnglishLevelsAccordion-module--content--16c72";
export var examplesColumn = "StrapiEnglishLevelsAccordion-module--examplesColumn--d2fd9";
export var hasTextWeightBold = "StrapiEnglishLevelsAccordion-module--has-text-weight-bold--542f9";
export var infoBlocks = "StrapiEnglishLevelsAccordion-module--infoBlocks--3c3b6";
export var isUppercase = "StrapiEnglishLevelsAccordion-module--is-uppercase--3839a";
export var root = "StrapiEnglishLevelsAccordion-module--root--71288";
export var text = "StrapiEnglishLevelsAccordion-module--text--98f2f";